
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.125.625H.875c-.422 0-.75.375-.75.75v2.25c0 .422.328.75.75.75h2.25c.375 0 .75-.328.75-.75v-2.25c0-.375-.375-.75-.75-.75zm0 7.5H.875c-.422 0-.75.375-.75.75v2.25c0 .422.328.75.75.75h2.25c.375 0 .75-.328.75-.75v-2.25c0-.375-.375-.75-.75-.75zm0 7.5H.875c-.422 0-.75.375-.75.75v2.25c0 .422.328.75.75.75h2.25c.375 0 .75-.328.75-.75v-2.25c0-.375-.375-.75-.75-.75zm19.5 1.125H6.875a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h15.75a.37.37 0 00.375-.375v-.75a.403.403 0 00-.375-.375zm0-15H6.875a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h15.75A.37.37 0 0023 2.875v-.75a.403.403 0 00-.375-.375zm0 7.5H6.875a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h15.75a.37.37 0 00.375-.375v-.75a.403.403 0 00-.375-.375z","fill":"currentColor"}})])
          )
        }
      }
    